import { NgModule } from '@angular/core';
import { PaginaNoEncontradaComponent } from './paginaNoEncontrada.component';
import { SinAutorizacionComponent } from './sinAutorizacion.component';
import { UnicaSesionComponent } from './unicaSesion.component';
import {RouterModule} from '@angular/router';
@NgModule( {
  imports: [ RouterModule ],
  declarations: [
    PaginaNoEncontradaComponent,
    SinAutorizacionComponent,
    UnicaSesionComponent
  ],
  bootstrap: [],
  providers: [],
  exports: []
} )
export class ErroresModule {
}
